import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "deviationsubmitpopup" */
        '../../redux/ModuleLoadable'
      )
  )
);

const LoadablePostPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "postpopup" */
        './PostPopup'
      )
  )
);

interface Props {
  deviation: PapiDeviation;
  requestClose: () => void;
}

const LazyPostPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyPostPopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} usePortal />}>
      <LoadableRedux />
      <LoadablePostPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyPostPopup.displayName = 'LazyPostPopup';

export default LazyPostPopup;
